<div class="card card-hover p-4 children-horizontal-gap-2" appHoverToggle=".hover-container">
    <p class="f-small fw-semibold">{{title()}}</p>
    @if(percentage() !== null) {
        <app-progress-bar-basic [percentage]="percentage()"></app-progress-bar-basic>
        <p class="f-small fw-medium text-neutral-700">{{percentage() | number: '1.0-1'}}%</p>
    }
</div>
 